// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1v_Nk","right":"Footer_right__1hmdr","buttons":"Footer_buttons__3-oO-"};